import { Button, ListItemIcon, MenuItem, Typography } from '@mui/material'
import { stringify } from 'query-string'
import { useTranslate } from 'ra-core'
import { forwardRef } from 'react'
import { useRecordContext, useResourceContext } from 'react-admin'
import { Link } from 'react-router-dom'

import { getResourceByName } from '../resources'

const useReferenceLink = ({ filterValues, reference, source, ...props }) => {
  const translate = useTranslate()
  const record = useRecordContext(props)
  const resource = useResourceContext()
  const sourceResource = getResourceByName(resource)
  const referenceResource = getResourceByName(reference)
  const genericLabel = `resources.${referenceResource.name}.name`
  let label
  let to
  if (source && record[source]) {
    label = translate(genericLabel, 1)
    to = { pathname: '/' + referenceResource.name + (record ? '/' + record[source] + '/show' : '') }
  } else {
    label = translate(genericLabel, 2)
    to = {
      pathname: '/' + referenceResource.name,
      search: stringify({
        filter: JSON.stringify({
          ...referenceResource.options.defaultFilterValues,
          ...filterValues,
          [sourceResource.options.referenceKey]: record ? record.id : null,
        }),
      }),
    }
  }
  return { to, label, ReferenceResourceIcon: referenceResource.icon }
}

const ReferenceLink = ({ filterValues, record, reference, source, variant }) => {
  const { to, label, ReferenceResourceIcon } = useReferenceLink({ filterValues, record, reference, source })
  return (
    <Button
      color="primary"
      component={Link}
      to={to}
      sx={{ display: 'inline-flex', alignItems: 'center' }}
      onClick={(e) => e.stopPropagation()}
      variant={variant}
    >
      {ReferenceResourceIcon && <ReferenceResourceIcon sx={{ pr: '0.25em' }} />}
      {label}
    </Button>
  )
}

export const ReferenceMenuItem = forwardRef(({ filterValues, record, reference, source }, ref) => {
  const { to, label, ReferenceResourceIcon } = useReferenceLink({ filterValues, record, reference, source })
  return (
    <MenuItem component={Link} to={to} ref={ref}>
      <ListItemIcon sx={{ minWidth: 5 }}>
        {ReferenceResourceIcon && <ReferenceResourceIcon color="inherit" />}
      </ListItemIcon>
      <Typography color="inherit">{label}</Typography>
    </MenuItem>
  )
})

export default ReferenceLink
